import { call, select } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { downloadFile } from 'utils/http/downloadFile';
import { selectRoomId } from 'features/room/roomSlice';
import { downloadPollTemplateService } from 'features/polls/services';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';
import * as Sentry from '@sentry/react';

export function* downloadPollTemplateSaga() {
  try {
    const roomId: string = yield select(selectRoomId);

    const response: AxiosResponse<Blob> = yield call(downloadPollTemplateService, roomId);
    const contentDisposition = response.headers['content-disposition'];

    yield call(downloadFile, response.data, contentDisposition);
  } catch (error) {
    yield call(notification, i18n.t('notifications:polls.template_download_error'));
    Sentry.captureException(error);
  }
}
